import { ProvinceMultiple } from "../../province-multiple";
import { Topic } from "./topic";
import { Product } from "./form/product";
import { CourseDates } from "./form/course-dates";
import { Center } from "./form/center";
import { Currency } from "./form/currency";
import { TotalMonthlyPayments } from "./form/total-monthly-payments";
import { PaymentType } from "./form/payment-type";
import { MaxQuota } from "./form/max-quota";
import { Price } from "./form/price";
import { NativeTeacher } from "./form/native-teacher";
import { TotalHours } from "./form/total-hours";
import { AttendanceType } from "./form/attendance-type";
import { TimeSchedule } from "./form/time-schedule";
import { Cities } from "./form/cities";
import { Infos } from "./form/infos";
import { Ajax } from "../../ajax";
import { Notifications } from "../../notifications";
export class CoursesBulk {
    constructor(form) {
        this.form = form;
        this.inputHandlers = [];
        this.sending = false;
        form
            .querySelectorAll(ProvinceMultiple.provinceContainerSelector)
            .forEach((provinceContainer) => {
            new ProvinceMultiple(provinceContainer);
        });
        this.inputHandlers.push(new Center(this.form));
        this.inputHandlers.push(new Currency(this.form));
        this.inputHandlers.push(new PaymentType(this.form));
        this.inputHandlers.push(new TotalMonthlyPayments(this.form));
        this.inputHandlers.push(new MaxQuota(this.form));
        this.inputHandlers.push(new Price(this.form));
        this.inputHandlers.push(new NativeTeacher(this.form));
        this.inputHandlers.push(new TotalHours(this.form));
        this.inputHandlers.push(new AttendanceType(this.form));
        this.inputHandlers.push(new Cities(this.form));
        this.inputHandlers.push(new Product(new Topic()));
        this.inputHandlers.push(new TimeSchedule(this.form));
        this.initializeDates();
        this.inputHandlers.push(new Infos(this.form));
        form.addEventListener("submit", (event) => {
            event.preventDefault();
        });
        form.querySelector("#send-bulk-button").addEventListener("click", () => {
            this.send();
        });
    }
    send() {
        if (this.sending) {
            return;
        }
        document.querySelectorAll(".has-warning").forEach((element) => {
            element.classList.remove("has-warning");
        });
        this.sending = true;
        this.disableForm();
        const formData = new FormData();
        const isFormValid = this.inputHandlers.every((currentValue) => currentValue.validate());
        if (!isFormValid) {
            this.sending = false;
            this.enableForm();
            return;
        }
        this.inputHandlers.forEach((inputHandler) => {
            inputHandler.addToFormData(formData);
        });
        const ajax = new Ajax(this.form.action, "POST");
        ajax.data = formData;
        ajax.errorCallback = (data) => this.onSendingError(data);
        ajax.successCallback = (data) => this.onSendingSuccess(data);
        ajax.send();
    }
    disableForm() {
        this.form
            .querySelectorAll("input, select")
            .forEach((input) => {
            input.setAttribute("disabled", "disabled");
        });
    }
    enableForm() {
        this.form
            .querySelectorAll("input, select")
            .forEach((input) => {
            input.removeAttribute("disabled");
        });
    }
    onSendingSuccess(data) {
        this.sending = false;
        if (!data.error) {
            Notifications.successCookie(courseSaved, "");
            window.history.back();
        }
        this.enableForm();
    }
    onSendingError(data) {
        this.sending = false;
        this.enableForm();
    }
    initializeDates() {
        this.datesWrapper = document.querySelector(CourseDates.datesWrapperSelector);
        if (this.datesWrapper) {
            const addDateButton = document.querySelector(CoursesBulk.addDateButtonSelector);
            if (addDateButton) {
                addDateButton.addEventListener("click", () => this.addDate());
            }
        }
        this.addDate();
    }
    addDate() {
        const onDelete = (dates) => this.removeInputHandler(dates);
        this.inputHandlers.push(new CourseDates(this.datesWrapper, onDelete));
    }
    static init() {
        const form = document.querySelector("form.js-course-bulk");
        if (form) {
            new CoursesBulk(form);
        }
    }
    removeInputHandler(dates) {
        this.inputHandlers = this.inputHandlers.filter((input) => input !== dates);
    }
}
CoursesBulk.addDateButtonSelector = ".js-add-dates";
